import * as actionTypes from "./constants";

const initialState = {
  processing: false,
  error: false,
  loading: true,
};

export default function ResetReducer(state = initialState, action) {
  switch (action.type) {
    case actionTypes.RESET_PASSWORD_INIT_ACTION:
      return {
        ...state,
        loading: true,
      };
    case actionTypes.RESET_PASSWORD_SUCCESS_ACTION:
      return {
        ...state,
        loading: false,
      };
    case actionTypes.RESET_PASSWORD_FAIL_ACTION:
      return {
        ...state,
        loading: false,
      };
    default:
      return {
        ...state,
      };
  }
}
